import {ViewType} from "../../gd/const/views/view-type"
import ProjectSession from "../../model2/project/project-session"
import ProjectSessionCollection from "../../model2/project/collection"
import {ProjectSystemType} from "../../model2/project/types"

const commonTypes = [
    ProjectSystemType.PROJECT,
    ProjectSystemType.FOLDER,
    ProjectSystemType.BACKLOG,
    ProjectSystemType.SPRINT,

    ProjectSystemType.PAGE,
    ProjectSystemType.CATEGORY,
    ProjectSystemType.EMBED,

    ProjectSystemType.SECTION,
    ProjectSystemType.WORKSPACE,
]

export default function getAvailableProjectsByViewType(viewType: ViewType) {
    let res

    switch (viewType) {
        case ViewType.PROJECT_LIST:
        case ViewType.CUSTOM_VIEW_TASKS_LIST:
        case ViewType.PROJECT_TABLE:
        case ViewType.CUSTOM_VIEW_TASKS_TABLE:
        case ViewType.PROJECT_BOARD:
        case ViewType.CUSTOM_VIEW_BOARD:
        case ViewType.PROJECT_GANTT:
        case ViewType.CUSTOM_VIEW_GANTT:
        case ViewType.PROJECT_WORKLOAD:
        case ViewType.CUSTOM_VIEW_WORKLOAD:
        case ViewType.CUSTOM_VIEW_ACTIVITY:
        case ViewType.CUSTOM_VIEW_WHATS_DONE:
        case ViewType.CUSTOM_VIEW_PASTDUE:
        case ViewType.CUSTOM_VIEW_PRIORITIES:
        case ViewType.CUSTOM_VIEW_ACTION_REQUIRED:
        case ViewType.CUSTOM_VIEW_TASKS_BY_USER: {

            const projects: ProjectSession[] = _.filter(gd.session.projects.models, (project: ProjectSession) => {
                return [
                    ...commonTypes,
                    ProjectSystemType.SINGLE_VIEW_TASK_BOARD,
                    ProjectSystemType.SINGLE_VIEW_TASK_LIST,
                ].includes(project.systemType)
            })
            res = new ProjectSessionCollection(projects)
        }
            break

        case ViewType.PROJECT_CALENDAR:
        case ViewType.CUSTOM_VIEW_CALENDAR:
        case ViewType.CUSTOM_VIEW_EVENTS_SUMMARY: {

            const projects: ProjectSession[] = _.filter(gd.session.projects.models, (project: ProjectSession) => {
                return [
                    ...commonTypes,
                    ProjectSystemType.SINGLE_VIEW_TASK_BOARD,
                    ProjectSystemType.SINGLE_VIEW_TASK_LIST,
                    ProjectSystemType.SINGLE_VIEW_MEETINGS,
                ].includes(project.systemType)
            })
            res = new ProjectSessionCollection(projects)
        }
            break

        case ViewType.PROJECT_EXPENSES:
        case ViewType.CUSTOM_VIEW_EXPENSES: {

            const projects: ProjectSession[] = _.filter(gd.session.projects.models, (project: ProjectSession) => {
                return [
                    ...commonTypes,
                    ProjectSystemType.SINGLE_VIEW_EXPENSES,
                ].includes(project.systemType)
            })
            res = new ProjectSessionCollection(projects)
        }
            break
    }

    return res
}